import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import ErrorPage from "../components/UI/Error/ErrorPage";
import IsLoggedIn from "./IsLoggedIn";
import NotLoggedIn from "./NotLoggedIn";
import pagesData from "./pagesData";
import { AdminLayout } from "../pages/admin";
import { adminRoutes } from "../pages/admin";

const Router = () => {
  const { user } = useSelector((state) => ({ ...state }));

  // Keyed by path (unique) rather than title: several pages share a title
  // ("profile" x6, "messages" x2), which produced duplicate-key warnings.
  const pageRoutesOptional = pagesData
    .filter(({ priv }) => priv === "optional")
    .map(({ path, element }) => {
      return <Route key={path} path={`/${path}`} element={element} exact />;
    });

  const pageRoutes = pagesData
    .filter(({ priv }) => priv === false)
    .map(({ path, element }) => {
      return <Route key={path} path={`/${path}`} element={element} exact />;
    });

  const pageRoutesPriv = pagesData
    .filter(({ priv }) => priv === true)
    .map(({ path, element }) => {
      return <Route key={path} path={`/${path}`} element={element} exact />;
    });

  return (
    <Routes>
      {/* Admin panel - separate layout, own auth check inside AdminLayout */}
      <Route path="administrator" element={<AdminLayout />}>
        {adminRoutes}
      </Route>

      <Route
        element={
          user.userinfo ? (
            <IsLoggedIn user={user} />
          ) : (
            <NotLoggedIn user={user} />
          )
        }
      >
        {pageRoutesOptional}
      </Route>
      <Route element={<IsLoggedIn user={user} />}>{pageRoutesPriv}</Route>
      <Route element={<NotLoggedIn user={user} />}> {pageRoutes}</Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default Router;
